// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3Rrbq","log":"ModalInventoryLogs_log__1wIvC","date":"ModalInventoryLogs_date__kvJCz","userName":"ModalInventoryLogs_userName__251lZ"};